import React from 'react'
import { Feed } from 'semantic-ui-react';
import momentDateAndTime from '../../../helpers/momentDateAndTime'
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import ImageAvater from '../../drive/Components/ImageAvater';
import AttachmentDisplay from './AttachmentDisplay';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Attachments Card')
    }
})
class Attachments extends React.Component {

    render() {
        let attachments;
        if (this.props.attachments && this.props.attachments.length > 0) {

            attachments = this.props.attachments.map((document, i) => {

                return <Feed key={i} className={`issueMessage bg-white pad_5`} style={{ padding: 0, margin: "10px 0 0 0", background: "none" }} >
                    <Feed.Event>
                        <ImageAvater user={document.uploadedBy} className="clr-white" />
                        <Feed.Content>
                            <Feed.Summary>
                                <span style={{ margin: "3px 0 0 0", display: "inline-block" }}>
                                    {document && document.uploadedBy ?
                                        <span> {document.uploadedBy.firstName} {document.uploadedBy.lastName}</span> : "NA"
                                    }
                                </span>

                                <span className="pull-right">
                                    {momentDateAndTime(document.uploadedAt)}
                                    <br />
                                </span>
                            </Feed.Summary>
                        </Feed.Content>
                    </Feed.Event>
                    <Feed.Event>
                        <Feed.Content>
                            <AttachmentDisplay
                                document={document}
                                user={this.props.user}
                                resourceId={this.props.resourceId}
                                entityName={this.props.entityName}
                                initiativeStatus={this.props.initiativeStatus}
                                playbookStatus={this.props.playbookStatus}
                                accountId={this.props.accountId}
                                isPublic={this.props.isPublic}
                                selectedOrganization={this.props.selectedOrganization}
                                selectedPlaybook={this.props.selectedPlaybook}
                                selectedInitiative={this.props.selectedInitiative}
                                currentOrganization={this.props.currentOrganization}
                                selectedData={this.props.selectedData}
                                to={this.props.to}
                                isAuthor={this.props.isAuthor}
                                status={this.props.status}
                                isWorkspaceOwner={this.props.isWorkspaceOwner}
                                isContributor={this.props.isContributor}

                            />
                        </Feed.Content>
                    </Feed.Event>

                </Feed>
            })
        } else {
            attachments = "No Attachments Added"
        }

        return (
            <div>
                {attachments}
            </div>
        )
    }
}

export default Attachments;